import { Card, CardContent, CardTitle, CardHeader, Button } from 'app-template-lib/components/shadcn';
import { ChevronRight } from 'lucide-react';
import { MouseEventHandler, useCallback } from 'react';

export interface SeisakuCardProps {
    seisakuShisakus: { id: string; seisaku_shisaku_name: string | null | undefined; jigyoCount?: number }[];
    visibleJigyoCount?: boolean;
    onClickSeisakuButton: (value: string) => void;
}

/**
 * 政策カードコンポーネント
 * @param param0
 * @returns
 */
export function SeisakuCards({ seisakuShisakus, visibleJigyoCount = true, onClickSeisakuButton }: SeisakuCardProps) {
    /**
     * 事業カードクリック時のイベントハンドラ
     * @param event
     */
    const handleClickShisakuCard: MouseEventHandler<HTMLButtonElement> = useCallback(
        (event) => {
            if (onClickSeisakuButton) {
                onClickSeisakuButton(event.currentTarget.value);
            }
        },
        [onClickSeisakuButton]
    );

    return (
        <Card className="bg-secondary  rounded-t-xl  shadow-none border-none mx-2 md:mx-0">
            <CardHeader className="bg-primary rounded-t-xl">
                <CardTitle className="text-white font-normal">政策から事業を確認する</CardTitle>
            </CardHeader>
            <CardContent className="container mx-auto grid grid-cols-1 shadow-none border-none pt-3 p-3 gap-2">
                {seisakuShisakus.map((seisaku) => (
                    <Button
                        key={seisaku.id}
                        variant={'ghost'}
                        value={seisaku.id}
                        onClick={handleClickShisakuCard}
                        className="min-w-fit h-full p-4 rounded-xl border-card bg-card shadow-none border-none items-center flex justify-between "
                    >
                        <h3 className="text-sm text-wrap text-left">{seisaku.seisaku_shisaku_name}</h3>
                        <div className="flex justify-between items-center">
                            {/* {visibleJigyoCount && <div className="text-sm text-right">{seisaku.jigyoCount} 件</div>} */}
                            <ChevronRight />
                        </div>
                    </Button>
                ))}
            </CardContent>
        </Card>
    );
}
